<template>
    <div style="height:100vh;">
        <!-- 顶部 标题栏 -->
        <van-nav-bar left-arrow style="position:relative;background-color:#393a3f;;" @click-left="handelLeftMenuFunc()" @click-right="showSerialPannel=!showSerialPannel">
            <template #left>
                <van-icon name="arrow-left" size="18" color='white' />
            </template>
            <template #title>
                <span style="color: white;font-weight: bold;">检查视频</span>
            </template>
        </van-nav-bar>
        <van-grid v-if='VideoList&&VideoList.length>0' :border="false" :column-num="1">
            <van-grid-item v-for='(item,index) in VideoList' :key='index'>
                <van-image  :src="imageUrl" style="background-color: rgb(61, 61, 61);width: 80%;" @click='handerPlayVideo(item.Url)'>
                    <template v-slot:error>加载失败</template>
                </van-image>
                <p>{{item.Name}}</p>
            </van-grid-item>
        </van-grid>
        <van-grid v-else :border="false" :column-num="2">
            <p style="font-size: 16px;font-weight: bold;margin: 10px 20px ;">没有查询到该患者的检查视频数据！</p>
        </van-grid>
        <MediaPlayer ref='mediaPlayer'/>
    </div>
</template>
<script>
    /* eslint-disable no-unused-vars */
    /* eslint-disable no-debugger */
    import { ImagePreview, Lazyload  } from 'vant'
    import { GetPatientReportImageInfos } from '@/api/CloudFilmService'
    import { GetFileServiceUrl ,GetGoBackUrlParms} from '../../utils/cacheUtils'
    import  MediaPlayer from "@/components/MediaPlayer"
    export default {
        components: {
            MediaPlayer
        },
        data() {
            return {
                imageUrl: require('@/assets/play.png'),
                // ImageList:[],
                VideoList:[],
            }
        },
        methods: {
            //查看图片
            handerImagePreview() {
                ImagePreview({images: this.ImageList,closeable: true});
            },
             //查看视频
            handerPlayVideo(url){
                // window.location.href= url;
                this.$refs.mediaPlayer.ShowPlayer(url)
            },
            //返回菜单
            handelLeftMenuFunc(){
                 this.$router.push({path:'/reportView?'+GetGoBackUrlParms()})
            }
        },
        mounted() {
            this.VideoList = []
            GetPatientReportImageInfos({ patientreportID: this.$route.query.reportInfoID }).then(async resp => {
                if (resp && resp.Success && resp.Result) {
                    const fileServiceUrl = await GetFileServiceUrl()
                    //检查的视频
                    var videoData= resp.Result.find(c => c.Category === 4)
                    if(videoData && videoData.Images && videoData.Images.length>0){
                        this.VideoList= videoData.Images.map(c=>{ 
                            return { 
                                Name:c.ImageRelaFileName.substring(c.ImageRelaFileName.lastIndexOf('\\')+1).toLowerCase(),
                                Url:fileServiceUrl+c.ImageRelaFileName 
                            }
                         })
                    }
                }
            })
        },
    };
</script>

<style scoped>
    /**rest**/
    body,
    ul,
    li,
    section,
    div {
        padding: 0;
        margin: 0;
    }

    body {
        font-family: Arial, Roboto, "Droid Sans", "Hiragino Sans GB", STXihei,
            "sans-serif";
        width: 100%;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-text-size-adjust: none;
    }
</style>